import type { SharedData } from '@/types';
import { usePage } from '@inertiajs/react';

export interface ContentPageDates {
    published: string;
    modified: string;
}

export type ContentPageRoute = string;

/**
 * Publish/modify dates for public content pages, for SEO structured data.
 *
 * Sourced server-side from the metadata manifest (`meta.published` in page JSON +
 * git last-modified per locale page file). Degrades gracefully when the manifest is
 * missing: the dates are simply omitted from structured data rather than
 * crashing the page.
 */
export function useContentPageSeoDates(routeName: ContentPageRoute): {
    datePublished?: string;
    dateModified?: string;
} {
    const { contentPageDates } = usePage<SharedData>().props;
    const dates = contentPageDates?.[routeName];

    if (!dates) {
        if (import.meta.env.DEV) {
            console.warn(`Missing content page metadata for route: ${routeName}. Run "composer content-page-metadata:build".`);
        }

        return {};
    }

    return {
        datePublished: dates.published,
        dateModified: dates.modified,
    };
}
